// Warning: Edit this file may corrupt version control for the project. Refrain from unnecessary changes.
const version = 'VERSION_NUMBER';
export default version;
